import { Link } from "react-router-dom";
import { ShoppingBag, ShieldCheck } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { VultLogo } from "./Logo";

const LINKS = [
  { label: "Lançamentos", href: "#catalogo" },
  { label: "Marcas", href: "#marcas" },
  { label: "Categorias", href: "#categorias" },
  { label: "Ofertas", href: "#catalogo" },
];

export function Navbar() {
  const { cartCount, setCartOpen } = useStore();
  return (
    <header data-testid="vult-navbar" className="fixed top-0 left-0 right-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <a data-testid="vult-nav-logo-link" href="#inicio" className="shrink-0">
          <VultLogo />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              data-testid={`vult-nav-brand-filter-${l.label.toLowerCase()}`}
              href={l.href}
              className="font-mono text-xs font-bold uppercase tracking-widest text-slate-600 transition-colors hover:text-vult-red"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link
            data-testid="vult-admin-login-trigger"
            to="/admin"
            className="hidden items-center gap-1.5 rounded-full border border-slate-200 px-3 py-2 font-mono text-[11px] font-bold uppercase tracking-widest text-slate-500 transition-colors hover:border-slate-900 hover:text-slate-900 sm:flex"
          >
            <ShieldCheck size={14} /> Admin
          </Link>
          <button
            data-testid="vult-cart-toggle-btn"
            onClick={() => setCartOpen(true)}
            className="relative flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 font-mono text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-vult-red hover:text-slate-900"
          >
            <ShoppingBag size={16} />
            <span className="hidden sm:inline">Carrinho</span>
            {cartCount > 0 && (
              <span data-testid="vult-cart-badge-count" className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-vult-red px-1 font-mono text-[10px] font-bold text-slate-900 ring-2 ring-white">
                {cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
